module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-alternative-antriebe-7f4dce6f2106fd31bc0c1b1357a0b7df.svg";